import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { PREVIOUS_PAGE } from "../../constants/constants";

const PreviousLocationContext = createContext(null);

export function PreviousLocationProvider({ children }) {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState(() => {
    return sessionStorage.getItem(PREVIOUS_PAGE);
  });

  useEffect(() => {
    setPreviousPath(sessionStorage.getItem(PREVIOUS_PAGE));
    sessionStorage.setItem(PREVIOUS_PAGE, location.pathname);
  }, [location.pathname]);

  return (
    <PreviousLocationContext.Provider value={previousPath}>
      {children}
    </PreviousLocationContext.Provider>
  );
}

export function usePreviousLocation() {
  return useContext(PreviousLocationContext);
}
